// extracted by mini-css-extract-plugin
export var card = "VsCards-module--card--b2ecd";
export var cardHeading = "VsCards-module--cardHeading--9189b";
export var grid = "VsCards-module--grid--8f853";
export var label = "VsCards-module--label--93afd";
export var labelCompetitor = "VsCards-module--labelCompetitor--4ef18";
export var labelDot = "VsCards-module--labelDot--401ec";
export var labelPreset = "VsCards-module--labelPreset--4704a";
export var row = "VsCards-module--row--4b971";
export var text = "VsCards-module--text--2cc3a";